module.exports = __webpack_public_path__ + "assets/images/edge130-31aa9b93042bb2be2c3e28778e42be3f.jpg";